export const PROJECT = 'project'
export const ISSUE_TYPE = 'issuetype'
export const PARENT = 'parent'
export const SUMMARY = 'summary'
export const DESCRIPTION = 'description'
export const ASSIGNEE = 'assignee'
export const LABELS = 'labels'
export const PRIORITY = 'priority'
export const COMPONENTS = 'components'
